<template>
  <div class="generate-pdf-width">
    <div class="row">
      <button class="btn btn-primary" @click="savePdf">Save as PDF</button>
      <button class="btn btn-success ml-2" @click="print">Print</button>
    </div>
    <div id="printArea" class="container" ref="generatePdf">
      <div class="col-md-12 row">
        <div class="col-md-4">
          <img
            alt="Vue logo"
            src="../../assets/logomem.jpg"
            style="width:250px"
          />
        </div>
        <div class="col-md-4">
          <div>
            <h3>KV SISTEM D.O.O.</h3>
            <h6>Ul. Slobode 17</h6>
            <h6>81000 Podgorica</h6>
            <h6>Crna Gora</h6>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <h6>PIB : 02846829</h6>
            <h6>PDV : 30/31-10567-5</h6>
            <h6>Sifra dijelatnosti: 4651</h6>
            <h6>Ziro racun : 565-309-33</h6>
          </div>
        </div>
      </div>
      <div class="row ml-5">
        <div class="col-md-6">
          <h4>Radni nalog</h4>
          <h6>Broj: {{ data.worklogNumber }}</h6>
          <p>
            Datum prijave:
            {{ new Date(data.dateTicketWasOpened) | moment(filter) }}
          </p>
          <p v-if="data.dateTicketWasClosed != 0">
            Datum zavrsetka:
            {{ new Date(data.dateTicketWasClosed) | moment(filter) }}
          </p>
        </div>
        <div class="col-md-6">
          <h4>{{ data.customer }}</h4>
          <h6>Kontakt : {{ data.contactPerson }}</h6>
          <p>Broj telefona : {{ data.phoneNumber }}</p>
        </div>
      </div>
      <div class="row mt-4 ml-5">
        <div class="col-md-12">
          <h5>Prijava: {{ data.typeOfProblem }}</h5>
          <p>{{ data.problemDescription }}</p>
        </div>
        <div class="col-md-12" v-if="data.tasks && data.tasks.length > 0">
          <v-data-table
            :items-per-page="150"
            style="width:900px"
            :headers="columns"
            :items="data.tasks"
            class="elevation-1"
            :hide-default-footer="true"
          >
            <template v-slot:item.id="{ item }">
              <span>{{ createIndex(item, data.tasks) }}</span>
            </template>
            <template v-slot:item.dateTicketWasOpened="{ item }">
              <span>{{
                new Date(item.dateTicketWasOpened) | moment(filter)
              }}</span>
            </template>
            <template v-slot:item.sermat="{ item }">
              <span>Serviser: {{ item.person }}</span>
              <p>
                Datum:
                {{
                  typeof item.date === "number"
                    ? new Date(item.date)
                    : new Date(item.date.seconds * 1000) | moment(filter)
                }}
              </p>
              <span class="pr-3"> Lokacija : {{ item.location }}</span>
              <span>Radno vrijeme : {{ item.workTime }}</span>
              <p>Opis: {{ item.description }}</p>
            </template>
          </v-data-table>
          <div
            class="materials mt-3"
            v-if="data.materials && data.materials.length > 0"
          >
            <h6>Materijali:</h6>
            <v-data-table
              style="width:900px"
              :headers="[
                { value: 'materialName', text: 'Naziv' },
                { value: 'unit', text: 'Jedinica' },
                { value: 'value', text: 'Kolicina' }
              ]"
              :items="data.materials"
              :hide-default-footer="true"
              class="elevation-1"
              disable-pagination
              disable-sort
            ></v-data-table>
          </div>
        </div>
      </div>
      <div class="row mt-5 ml-5">
        <div class="col-md-6">
          <p>Serviser :</p>
          <div style="width:60%;border-bottom:1px solid black;"></div>
        </div>
        <div class="col-md-6">
          <p>Klijent :</p>
          <div style="width:60%;border-bottom:1px solid black;"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import "@/assets/generatePdf.css";
// import $ from "jquery";
export default {
  props: {
    data: Object
  },
  mounted() {
    console.log(this.data);
  },
  data() {
    return {
      filter: "",
      taskIds: [],
      columns: [
        { value: "id", text: "Rbr" },
        { value: "sermat", text: "Usluga/Materijal" },
        { value: "workTimeSpent", text: "Kolicina" },
        { value: "workTimeUnit", text: "j.m" }
      ]
    };
  },

  methods: {
    createIndex(item, checkArry) {
      var count = 0;
      if (item && checkArry) {
        checkArry.forEach((i, index) => {
          if (i === item) {
            count = index + 1;
          }
        });
        return count;
      }
    },
    savePdf() {
      // var divHeight = $("#printArea").height();
      // var divWidth = $("#printArea").width();
      var ratio = 1200 / 1100;
      this.$store.dispatch("isLoading", true);
      html2canvas(document.getElementById("printArea"), {
        height: 1200,
        width: 1000
      }).then(canvas => {
        var image = canvas.toDataURL("image/jpeg");
        var doc = new jsPDF(); // using defaults: orientation=portrait, unit=mm, size=A4
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();
        height = ratio * width;
        doc.addImage(image, "JPEG", 10, 0, width, height);
        doc.save("myPage.pdf");
        this.$store.dispatch("isLoading", false);
      });
    },
    print() {
      this.filter = "DD-MM-YYYY";
      this.$htmlToPaper("printArea");
      this.filter = "";
    }
  },
  filters: {
    moment: function(date) {
      var defaultFormat = "DD-MM-YYYY";
      // var formatTime = format ? format : defaultFormat;
      return moment(date).format(defaultFormat);
    }
  }
};
</script>
<style>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 80% !important;
  }
}
.materials {
  margin-bottom: 20px;
}
.v-data-footer {
  /* display: none; */
}
p {
  font-size: 17px;
}
</style>
